<!--
 Created by Yaroslav S. on 10/07/2024
 Copyright © 2020 Curriculum Ltd. All rights reserved.
-->

<div class="open-ai-section">
  <div class="open-ai-section-title">Open AI</div>

  <div class="form-fields">
    <div class="form-fields-label">Secret Key</div>
    <curr-input
      [formGroup]="form"
      controlName="openaiApiKey"
      class="full-width form-field"
      [errorMessage]="form.controls['openaiApiKey'].hasError('required') ? 'Secret Key is required' : ''"
    ></curr-input>
  </div>

  <curr-credits-error *ngIf="showError"></curr-credits-error>

  <div class="save-actions">
    <curr-button
      variant="contained"
      [isDisabled]="form.invalid || !openaiApiKey.dirty"
      (btnClick)="saveApiKey()"
      size="big"
      >SAVE</curr-button
    >
  </div>
</div>
